module.exports = __webpack_public_path__ + "static/img/pic_daoshi_bm@2x.118be33f.png";